export enum NOTIFICATION_IDS {
  FUNDER_SAVE = "FUNDER_SAVE",
}
